import { HORSEPOWER_RANGES } from "@/hooks/useFilters.js";

const HORSEPOWER_RANGE_BY_LABEL = new Map(
  HORSEPOWER_RANGES.map((r) => [r.label, r])
);

/**
 * @param {boolean} assetValue - asset.optimizationEnabled
 * @param {boolean|null} filterValue - filter choice: null = all, true = Yes, false = No
 * @returns {boolean}
 */
export function matchesOptimizationFilter(assetValue, filterValue) {
  return filterValue == null || assetValue === filterValue;
}

/**
 * @param {number|null|undefined} hp - asset.horsepower
 * @param {string[]} selectedLabels - selected range labels from filters.horsepowerRange
 * @returns {boolean}
 */
export function matchesHorsepowerRangeFilter(hp, selectedLabels) {
  if (!selectedLabels?.length) return true;
  if (typeof hp !== "number" || !Number.isFinite(hp)) return false;
  for (const label of selectedLabels) {
    const range = HORSEPOWER_RANGE_BY_LABEL.get(label);
    if (range && hp >= range.rangeLow && hp <= range.rangeHigh) {
      return true;
    }
  }
  return false;
}

/**
 * For when a user-entered value will be used in a regex but shouldn't act like one.
 * @param {string} value
 */
export function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
